/**
 * Application Routes Configuration
 */

export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  
  // Protected routes
  DASHBOARD: '/dashboard',
  DEVICES: '/devices',
  MAP: '/map',
  ANALYTICS: '/analytics',
  QUERIES: '/queries',
  USERS: '/users',
  SETTINGS: '/settings',
  INFLUXDB: '/influxdb',
  DYNAMODB: '/dynamodb',
  EXCEL: '/excel',
  
  // Default
  HOME: '/',
};

/**
 * Route permissions - which roles can access which routes
 */
export const ROUTE_PERMISSIONS = {
  [ROUTES.DASHBOARD]: ['viewer', 'operator', 'manager', 'admin', 'super-admin'],
  [ROUTES.DEVICES]: ['operator', 'manager', 'admin', 'super-admin'],
  [ROUTES.MAP]: ['viewer', 'operator', 'manager', 'admin', 'super-admin'],
  [ROUTES.ANALYTICS]: ['manager', 'admin', 'super-admin'],
  [ROUTES.QUERIES]: ['operator', 'manager', 'admin', 'super-admin'],
  [ROUTES.INFLUXDB]: ['operator', 'manager', 'admin', 'super-admin'],
  [ROUTES.DYNAMODB]: ['operator', 'manager', 'admin', 'super-admin'],
  [ROUTES.EXCEL]: ['operator', 'manager', 'admin', 'super-admin'],
  [ROUTES.USERS]: ['admin', 'super-admin'],
  [ROUTES.SETTINGS]: ['admin', 'super-admin'],
};

